/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from "react";
// eslint-disable-next-line react/prop-types
const ACTIVE = "ACTIVE";
function Status({ width = 85, height = 24, label, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 85 24"
      {...props}
    >
      <g
        id="Group_5074"
        data-name="Group 5074"
        transform="translate(-1382 -801)"
      >
        <g
          id="Rectangle_16"
          data-name="Rectangle 16"
          transform="translate(1382 801)"
          fill={label === ACTIVE ? "#e8ffdb" : "#FF425E"}
          stroke={label === ACTIVE ? "#1c9c29" : "#E8112D"}
          strokeWidth="1"
        >
          <rect width="85" height="24" rx="12" stroke="none" />
          <rect x="0.5" y="0.5" width="84" height="23" rx="11.5" fill="none" />
        </g>
        <g
          id="Group_5075"
          data-name="Group 5075"
          transform={label === ACTIVE ? "translate(12 1)" : "translate(5 0.5)"}
        >
          <text
            id={label || "DEACTIVATED"}
            transform={
              label === ACTIVE ? "translate(1391 817)" : "translate(1379 817)"
            }
            fill={label === ACTIVE ? "#1c9c29" : "#FFFFFF"}
            fontSize="12"
            fontWeight="500"
            fontFamily="Inter-Regular, Inter"
          >
            <tspan x="0" y="0">
              {label || "DEACTIVATED"}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}
export default Status;
